export function addUserDocument() {
  var newDocumentFields = $("#fields-documents > div:first")[0].outerHTML;
  var idToReplace = parseInt($('#fields-documents > div:first input')[0].id.match(/\d+/)[0]);
  var newId = $("input:file").length;
  newDocumentFields = newDocumentFields.replace ( new RegExp(`\\[${idToReplace}\\]`, 'g'),`[${newId}]` );
  $("#fields-documents").append(newDocumentFields);
  $("#fields-documents > div:last input").val('');
  $("#fields-documents > div:last").find('.error').remove();
}
